import { render, staticRenderFns } from "./ReconBasketMenu.vue?vue&type=template&id=84f86372&scoped=true&"
import script from "./ReconBasketMenu.vue?vue&type=script&lang=ts&"
export * from "./ReconBasketMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ReconBasketMenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReconBasketMenu.vue?vue&type=style&index=1&id=84f86372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f86372",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VIcon,VMenu,VRow,VSelect,VSheet,VSpacer,VTooltip})
